module.exports = __webpack_public_path__ + "img/logo.4d9e0031.svg";